import { PropertyFormFieldConfig } from "@/constants/propertyFields";
import { EmeraldInputV2 } from "@emerald-react/input-v2";
import { usePropertyFormField } from "@hooks/usePropertyFormField";
import {
  useCurrentProperty,
  useCurrentPropertyId,
  useSurvey,
} from "@hooks/useSurveySelectors";
import classNames from "classnames";
import CustomFieldInput from "./CustomFieldInput";

interface PropertyDisplayFieldsForm {
  fieldAttribute?: PropertyFormFieldConfig;
  field: string;
  rows?: number;
  closeHandler?: () => void;
}

const PropertyDisplayFields = ({
  fieldAttribute,
  field,
  rows,
  closeHandler,
}: PropertyDisplayFieldsForm) => {
  const currentPropertyId = useCurrentPropertyId();
  const currentProperty = useCurrentProperty();
  const currentSurvey = useSurvey();

  // Only render children if we have a valid property selected
  if (!currentPropertyId || !currentProperty) {
    return null;
  }

  const fieldValue = fieldAttribute?.fieldKey || field;
  const size = fieldAttribute?.size || "medium";
  const {
    activeFieldRuleList,
    getFieldValue,
    handleFocus,
    handleInputChange,
    handleBlur,
  } = usePropertyFormField(currentProperty, currentPropertyId, currentSurvey);

  if (fieldAttribute?.fieldKey) {
    const rawValue =
      currentProperty[fieldValue as keyof typeof currentProperty];
    const stringValue =
      rawValue != null &&
      typeof rawValue !== "object" &&
      typeof rawValue !== "boolean"
        ? String(rawValue)
        : undefined;

    const label = (fieldAttribute?.label || field).replace(/\s-/g, "");

    return (
      <EmeraldInputV2
        type={size === "small" ? "text" : "textarea"}
        label={fieldAttribute?.label || field}
        value={getFieldValue(stringValue, fieldValue)}
        size="small"
        className={classNames("without-label", {
          boldLabel: activeFieldRuleList?.includes(label),
        })}
        onFocus={() => handleFocus(stringValue, fieldValue)}
        onBlur={(e) => handleBlur(e, fieldValue, label)}
        rows={rows}
        onChange={(e) => handleInputChange(e, fieldValue)}
      />
    );
  } else {
    const customField = currentSurvey?.customFields?.find((rule) => {
      return (
        rule.name?.toLocaleLowerCase().replace(/\s/g, "") ===
        field.toLocaleLowerCase().replace(/\s/g, "")
      );
    });

    const modifiedCustomField = {
      id: customField?.customFieldId || "",
      label: customField?.name || "",
      value:
        currentProperty?.customFields.find(
          (each) =>
            each.customField.customFieldId === customField?.customFieldId,
        )?.value || "",
    };
    return (
      <CustomFieldInput
        eachField={modifiedCustomField}
        activeFieldRuleList={activeFieldRuleList}
        propertyId={currentPropertyId}
        onClose={closeHandler}
      />
    );
  }
};

export default PropertyDisplayFields;
